import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './ThemeContext';
import { supabaseConfigError } from './supabase';

// ── Responsive scaling ───────────────────────────────────────────────────────
// The portal is a fixed-px desktop layout (min-width ~1200). At native scale it
// fits small laptops (13" MacBook) but wastes space on large monitors. We zoom
// the whole document up on wider screens.
//
// CSS `zoom` + media queries oscillate (applying a zoom shifts the CSS viewport
// width back across the breakpoint), so we drive it from JS instead: reset to
// native, measure the true width, then apply a proportional zoom. Reading the
// width forces a synchronous layout at zoom 1, so the measurement is never
// itself affected by the zoom we're about to set — no feedback loop.
function applyResponsiveScale() {
  const el = document.documentElement;
  el.style.zoom = '1';
  const w = el.clientWidth;            // true CSS px at native scale
  // 1.0 below ~1600px (fits 13"), ramping gently up to 1.25 on wide desktops.
  const scale = Math.min(1.25, Math.max(1, 1 + (w - 1600) / 3800));
  el.style.zoom = String(scale);
}
let scaleRaf = 0;
function scheduleScale() {
  cancelAnimationFrame(scaleRaf);
  scaleRaf = requestAnimationFrame(applyResponsiveScale);
}
applyResponsiveScale();
window.addEventListener('resize', scheduleScale);

const root = ReactDOM.createRoot(document.getElementById('root'));

if (supabaseConfigError) {
  root.render(
    <div style={{
      minHeight: '100vh', background: '#020617', color: '#e2e8f0',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24, fontFamily: 'Inter, sans-serif',
    }}>
      <div style={{
        maxWidth: 560, padding: 28, borderRadius: 10,
        background: 'linear-gradient(180deg, rgba(15,31,61,0.6), rgba(10,22,40,0.6))',
        border: '1px solid rgba(239,68,68,0.30)',
      }}>
        <div style={{
          fontFamily: "'JetBrains Mono', monospace", fontSize: 10,
          color: '#ef4444', textTransform: 'uppercase', letterSpacing: '0.12em',
          marginBottom: 8, fontWeight: 600,
        }}>
          Configuration error
        </div>
        <h1 style={{ margin: '0 0 12px', fontSize: 18, fontWeight: 700 }}>
          Graphvine portal can&apos;t start
        </h1>
        <p style={{ margin: 0, fontSize: 13, color: '#94a3b8', lineHeight: 1.55 }}>
          {supabaseConfigError}
        </p>
      </div>
    </div>
  );
} else {
  root.render(
    <React.StrictMode>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </React.StrictMode>
  );
}

reportWebVitals();
